(() => {
  const KEY = 'sakura:collection-scroll:v1';
  const MAX_AGE = 30 * 60 * 1000;
  const isCollection = /^\/collections\//.test(location.pathname);

  // A separate editorial page temporarily uses manual restoration. Reset it
  // everywhere else so the setting cannot leak into collection navigation.
  if (!/\/pages\/todays-outfit-edit/.test(location.pathname) && 'scrollRestoration' in history) {
    history.scrollRestoration = 'auto';
  }

  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { return null; }
  };
  const write = (value) => {
    try { sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (_) {}
  };
  const clear = () => {
    try { sessionStorage.removeItem(KEY); } catch (_) {}
  };
  const currentUrl = () => location.pathname + location.search;

  if (isCollection) {
    document.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      let target;
      try { target = new URL(link.href, location.href); } catch (_) { return; }
      if (target.origin !== location.origin || !/^\/products\//.test(target.pathname)) return;
      write({
        url: currentUrl(),
        path: location.pathname,
        y: Math.max(0, Math.round(scrollY)),
        time: Date.now()
      });
    }, true);

    const restoreFromState = (pageShowEvent) => {
      const state = read();
      const sameCollection = state && (state.url === currentUrl() || state.path === location.pathname);
      const valid = sameCollection && Number.isFinite(state.y) && Date.now() - state.time < MAX_AGE;
      if (!valid) {
        if (state && Date.now() - state.time >= MAX_AGE) clear();
        return;
      }
      const restoreOnce = () => requestAnimationFrame(() => requestAnimationFrame(() => {
        const max = Math.max(0, document.documentElement.scrollHeight - innerHeight);
        const destination = Math.max(0, Math.min(state.y, max));
        // Safari can report a BFCache hit while restoring the page at 0. Only
        // correct a real mismatch and never keep fighting later user scroll.
        if (Math.abs(scrollY - destination) > 8) scrollTo(0, destination);
        write({ ...state, restoredAt: Date.now() });
      }));
      // BFCache normally restores perfectly. The one-shot check above is only
      // a safety net for iOS edge-swipe returns that occasionally land at 0.
      if (pageShowEvent && pageShowEvent.persisted) {
        restoreOnce();
        return;
      }
      // If BFCache was missed, perform one fallback restore after the server-rendered
      // collection grid has completed its first layout, then immediately yield.
      if (state.restoredAt) return;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreOnce, { once: true });
      else restoreOnce();
    };

    addEventListener('pageshow', restoreFromState);
  }
})();
